<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <div class="card">
              <div class="card-content">
                <div class="modal fade text-left" id="reset-password-modal" tabindex="-1" role="dialog"
                  aria-labelledby="create-modal-title" aria-hidden="true">
                </div>
                <!--user edit confirmation modal-->
                <div class="modal fade text-left" id="user-edit-success-modal" tabindex="-1" role="dialog"
                  aria-labelledby="create-modal-title" aria-hidden="true">
                  <div class="modal-dialog modal-lg modalPopStyle" role="document">
                    <div class="modal-content resetPasswordDialogue">
                      <div class="modal-header ">
                        <h3 class="modal-title resetPasswordHeading " id="create-modal-title">{{
                            $t('users_edit_module_confirmation_popup_heading')
                        }}</h3>
                        <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
                          <img :src="closeImage" alt="close image">
                        </button>
                      </div>
                      <div class="modal-body">

                        <h3 class="modal-title resetPasswordSuccessHeading divStyleModall" id="create-modal-title">"{{
                            $t('users_edit_module_confirmation_popup_message')
                        }}”</h3>
                      </div>
                      <div class="modal-footer modalFooter">

                        <button type="button" class="btn btn-primary ml-1 okButtonStyle" data-dismiss="modal"
                          aria-label="Close">
                          <em class="bx bx-check d-block d-sm-none"></em>
                          <span class="d-none d-sm-block">{{ $t('users_edit_module_confirmation_popup_ok_button')
                          }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-header headerAlign">
                  <div>
                    <router-link :to="{name:'CLOUsersPage', params:{org: orgId }}">
                    <span style="display: inline-block; cursor: pointer" >
                      <img :src="backIcon" class="titleFont" alt="back icon">
                      <h5 style="display: inline-block; transform: translate(23px, -20px);" class="backFont "> {{
                          $t('clo_user_view_back_button')
                      }} </h5>
                    </span>
                  </router-link>
                    <h5 class="card-title headingAlign">{{ $t('clo_user_edit_heading') }} </h5>
                  </div>
                </div>
                <div class="card-body card-dashboard">
                  <Alert :text="$t('users_edit_module_reset_password_validation_required_error')" type="danger"
                    dismissable="false" v-if="requiredAllError" />
                    <Alert :text="$t('pacto_users_module_validation_phone_error')" type="danger" dismissable="false"
                v-if="phoneValidError && !loadingData" />
                  <Alert :text="apiErrorText" type="danger" dismissable="false" v-if="apiErrorText != ''" />
                  <form @submit.prevent="handleSubmit">
                    <div class="form-group row">
                      <div class="col-md-5">
                        <div>
                        <label for>{{ $t('clo_user_view_first_name_label') }}</label>
                        <input type="text" class="form-control inputTab" v-model="target.name" />
                      </div>
                      <div class="pt-2">
                        <label for>{{ $t('clo_user_view_email_label') }}</label>
                        <input type="text" class="form-control inputTab" v-model="target.email" disabled/>
                      </div>
                      <div class="pt-2">
                        <label for>{{ $t('clo_user_view_status_label') }}</label>
                        <select class="form-control inputTab" v-model="target.status">
                          <option selected value="joined"> {{ $t('clo_user_status_dropdown_active_option') }} </option>
                          <option value="banned"> {{ $t('clo_user_status_dropdown_inactive_option') }} </option>
                        </select>
                      </div>
                      


                    </div>
                      <div class="col-md-1"  >
                        <div class="text-center"> 
                  <div class="spinner-border text-primary loaderCenterClass"  v-if="loadingData" role="status" style="opacity: .6">
                    <span class="sr-only">{{ $t('common_module_loader_label') }}</span>
                  </div>
                </div> 
                      </div>
                      <div class="col-md-5">
                        <div>
                        <label for>{{ $t('clo_user_view_role_label') }}</label>
                        <select class="form-control inputTab" v-model="target.type" disabled>
                          <option selected value="cloowner">{{ $t('role_cloowner') }}
                          </option>
                          <option value="project_manager">{{ $t('role_projectmanager') }}
                          </option>
                          <option value="complaint_feedback_lead">{{
                              $t('role_complaints_and_feedback_lead')
                          }} </option>
                          <option value="clopacto_user_success_lead">{{
                              $t('clopacto_user_success_lead')
                          }} </option>
                        </select>
                        </div>
                        <div class="pt-2">
                          <label for>{{ $t('clo_user_view_phone_label') }}</label>
                        <div class="marginDiv">
                          <PhoneNumberInput :phoneNumber="phoneNumber" v-model="phoneNumber"  autoformat addClass="form-control inputTabData" @validate="telValidate" />
                        </div>
                        </div>
                        <div class="pt-2">
                          <label for>{{ $t('clo_user_view_country_label') }}</label>
                        <select class="form-control inputTab" v-model="countryData">
                          <option value="default" disabled>{{ $t('clo_user_add_user_popup_country_dropdown_default') }}
                          </option>
                          <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                              countryName(country)
                          }}
                          </option>

                        </select>
                        </div>
                      </div>
                  </div>
                    <!-- end -->
                    <div v-if="target.lastEditedBy">
                      <p class="text-muted" style="margin-bottom: 1px">
                        {{ $t('user_edit_module_label_last_edited_by') }}:
                      </p>
                      <p>{{ target.lastEditedBy.name }} {{ $t('on') }} {{
                          $filters.formatDate(target.lastEditedBy.lastEditedAt)
                      }}</p>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <router-link :to="{name:'CLOUsersPage', params:{org: orgId }}">
                  <button type="button" class="btn btn-light-secondary">
                    <em class="bx bx-x d-block d-sm-none"></em>
                    <span class="d-none d-sm-block " style="color: white" >{{
                        $t('clo_user_view_cancel_button')
                    }}</span>
                  </button>
                </router-link>
                  <button type="button" class="btn btn-primary ml-1">
                    <em class="bx bx-check d-block d-sm-none"></em>
                    <span class="d-none d-sm-block" @click="submitChanges()">{{ $t('clo_user_view_save_changes_button')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import Alert from "@/components/Alerts";
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators';
import "@/app-assets/css/pages/authentication.css";
import { getCountryName } from '@/app-assets/js/get-countries.js'
import PhoneNumberInput from "@/components/PhoneNumberInput/PhoneNumberInput";

export default {
  components: {
    Alert,
    PhoneNumberInput
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      loadingData:true,
      target: {},
      userId: this.$route.params.uid,
      orgId: this.$route.params.org,
      backIcon: require('@/assets/backIcon.png').default,
      emailError: false,
      passwordError: false,
      confirmPasswordError: false,
      comparePasswordError: false,
      error: false,
      requiredPasswordError: false,
      phoneNumber: "",
      phoneValidError:false,
      requiredAllError: false,
      data: {},
      lastName: "",
      errorText: "",
      errorMessage: "",
      isSubmitted: false,
      modalEmail: "",
      modalPassword: "",
      modalPasswordConfirm: "",
      resetPasswordErrorText: "",
      submitStatus: false,
      requiredError: false,
      apiErrorText: "",
      dialCode: 0,
      closeImage: require('@/assets/close.png').default,
      countryData: 'default',
      totalCountries: [],
      language: localStorage.getItem('defaultLanguage')

    }
  },
  validations: {
    modalEmail: {
      required,
      email,
    },
    modalPassword: {
      required,
    },
    modalPasswordConfirm: {
      required,
    }
  },
  methods: {

    handleSubmit() {
      this.isSubmitted = true;
      this.v$.$touch();
    },
    scrollToTop() {
    window.scrollTo(0,0);
  },
    getUserById() {
      let self = this;
      this.$apiCall.get(`/v1/users/${this.userId}`).then((response) => {
        self.loadingData = false;
        self.target = response.data;
        self.phoneNumber = self.target.phoneNumber
        self.countryData = self.target.currentCountry
        console.log("orgidddddddddddddddddd", this.orgId)
      });
    },
   
   


    checkValue() {
      if (/[^a-zA-Z]/.test(this.target.firstName)) {
        this.errorMessage = 'Input value contains other syantax.';
      } else {
        this.errorMessage = '';
      }
    },
    telValidate(telnumber){
      console.log("validate-phone", telnumber)
      if (telnumber.valid) {
        this.phoneValidError = false
      } else {
        this.phoneValidError = true
      }
      console.log("phonevaliddddddd", this.phoneValidError)
    },

    submitChanges() {
      let self = this;
      if (self.language == "English") {
        self.language = "en"
      }
      self.submitting = true;
      console.log("target", self.target)
      if (self.target.firstName == '') {
        self.requiredAllError = true;
      }
      if (!self.target.phoneNumber == "") {
        self.requiredAllError = true;

      }
      self.requiredAllError = false
      self.data = {
        name: self.target.name,
        type: self.target.type,
        phoneNumber: self.phoneNumber,
        status: self.target.status,
        currentCountry: self.countryData,
        language: self.language
      }
      console.log("dataaaaaaaaaa", self.data)
      if(!self.phoneValidError ){
      this.$apiCall.patch(`v1/admins/${this.userId}`, self.data).then((response) => {
        const data = response.data;
        self.submitting = false;
        self.apiErrorText = false;
        $("#user-edit-success-modal").modal();
      })
        .catch((error) => {
          console.log("err", error)
          $.unblockUI();
          self.apiErrorText =
            `<strong>Ops!</strong> ${error.response.data.message}`;

        });
      }
    },
    routeTo() {
      this.$router.push({ name: 'AdminsPage' })
    },

    submitPassword() {
      let self = this;

      var block_ele = $("#reset-password-modal .modal-content");
      $(block_ele).block({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.v$.$touch();
      this.submitStatus = true;

      if (this.modalEmail == '') {
        self.requiredError = true;
        self.comparePasswordError = false;
        self.requiredPasswordError = false;
      }


      if (this.modalPassword == '') {
        self.requiredError = true;
        self.comparePasswordError = false;
        self.requiredPasswordError = false;
      }


      if (this.modalPasswordConfirm == '') {
        self.requiredError = true;
        self.comparePasswordError = false;
        self.requiredPasswordError = false;
      }

      if (this.modalPassword) {
        let regularExpression = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{7,}$/;
        if (!regularExpression.test(self.modalPassword)) {
          self.comparePasswordError = false;
          self.requiredError = false;
          self.requiredPasswordError = true;
        }
      }

      if (this.modalPassword && this.modalPasswordConfirm) {
        if (this.modalPassword != this.modalPasswordConfirm) {
          self.comparePasswordError = true;
          self.requiredError = false;
          self.requiredPasswordError = false;
        }
      }


      if (!this.v$.$invalid) {
        self.requiredError = false;
        self.requiredPasswordError = false;
        self.confirmPasswordError = false;
        self.comparePasswordError = false;
        self.passwordError = false;
        self.emailError = false;
        this.$apiCall
          .patch(`v1/admins/reset/password/${self.userId}`, {
            email: self.modalEmail,
            password: self.modalPassword,
            language: self.target.language
          })
          .then(function (response) {
            $("#reset-password-modal").modal('toggle');
            $("#reset-password-confirm-modal").modal();
          })
          .catch(function (error) {
            $(block_ele).unblock();
            self.resetPasswordErrorText =
              `<strong>Ops!</strong> ${error.response.data.message}`;
            self.v$.modalEmail.$model = "";
            self.modalPassword = "";
            self.modalPasswordConfirm = "";
          });
      }
    },
    getCountryData() {
      let self = this;
      this.$apiCall.get(`v1/clo-organization/${self.orgId}/countries`).then(function (response) {
        self.totalCountries = response.data
      })
    },
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase())
      }
    },
    dialogueClose() {
      self.requiredPasswordError = false;
      self.confirmPasswordError = false;
      self.comparePasswordError = false;
      self.passwordError = false;
      self.emailError = false;
    }
  },




  mounted() {
    this.getUserById()
    this.getCountryData()
    this.scrollToTop()

  }
}
</script>

<style scoped>
.inputTab {
  height: 3em;
  width: 35em;
}

@media (min-width: 768px) and (max-width: 1366px) {
  .inputTab {
    height: 3em;
    width: 27em;
  }
}

.titleFont {
  text-align: center;
  margin-right: 12%;

}
.loaderCenterClass{
  display: flex;
  align-items: center;
}

.headingAlign {
  margin-left: 31%;
  display: inline-block;
  transform: translate(101px, -20px);
}

@media (min-width: 768px) and (max-width:1366px) {
  .headingAlign {
    margin-left: 46%;
    display: inline-block;
    transform: translate(-145px, -20px);
  }
}

.backFont {
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 500;
}

.headerAlign {
  border-width: 2px;
  height: 6em;
}

.alert {
  padding: 5px 10px;
  border: 1px solid #ff72728a;
  display: inline-block;
  color: #d48888;
  border-radius: 4px;
}

.resetPasswordHeading {
  color: #4A0A1E;
  font-size: 18px !important;
  font-weight: 450 !important;
}

.inputHeight {
  height: 3.5em;
}

.modalPopStyle {
  margin-left: 44em;
  margin-top: 182px;
}

.okButtonStyle {
  width: 8em;
}

.modalFooter {
  border-top: 1px solid #DFE3E7;
}

.resetPasswordSuccessHeading {
  color: #767676;
  font-size: 20px !important;
  font-weight: 400 !important;
  text-align: center;
  margin-top: 4%;
}

.resetPasswordDialogue {
  height: 19em;
  border-radius: 1rem !important;
  margin-top: 35%;
}

.flagAlign {
  transform: translate(-35em, 0px);
  border: 0px;
}

@media (max-width:1366px) {
  .resetPasswordDialogue {
    height: 19em;
    border-radius: 1rem !important;
    transform: translate(-17em, -46px);
  }

  .flagAlign {
    transform: translate(-27em, 0px);
    border: 0px;
  }
}

.resetPasswordPopup {
  height: 28em;
  border-radius: 1rem !important;
  margin-top: 17em;
  margin-left: 6em;
}

.passwordTitle {
  white-space: nowrap;
  font-size: 14px;
}

.resetPasswordStyle {
  display: inline-block;
  transform: translate(81em, -56px);
  margin-left: 142px
}

@media (min-width: 768px) and (max-width: 1366px) {
  .resetPasswordStyle {
    display: inline-block;
    transform: translate(45em, -56px);
    margin-left: 142px
  }
}

.inputTabData {
  height: 3em;
  width: 35em;
  border: 1px solid #DFE3E7;
  border-radius: 0.267rem;
  color: #475F7B;
}

.vue-tel-input.form-control.inputTabData:focus-within {
  color: #475F7B;
  background-color: #FFFFFF;
  border-color: #5A8DEE;
  outline: 0;
  box-shadow: 0 3px 8px 0 rgb(0 0 0 / 10%);
}

.marginDiv {
  display: flex;
}

.buttonWidth {
  width: 8em;
}

@media (min-width: 768px) and (max-width: 1366px) {
  .inputTabData {
    height: 3em;
    width: 27em;
  }

  .marginDiv {
    display: flex;
    width: 33em;
  }
}
</style>
